import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import PaperImage from "src/modules/3rd-party-management/assets/images/paper.svg";
import { Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const InsolvencyPublications = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const rows = data?.insolvency_publications || [];

    if (!hasNonEmptyArray(rows)) {
        return null;
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('insolvency-publications')}
            className={activeAccordion === 'insolvency-publications' ? 'active' : ''}
            eventKey={'insolvency-publications'}
        >
            <Accordion.Header>
                <img src={PaperImage} alt="" />
                <span>{t('Insolvency Publications')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('Court')}</th>
                                <th>{t('Case ID')}</th>
                                <th>{t('Label')}</th>
                                <th>{t('Register')}</th>
                                <th>{t('Notice')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={row.insolvency_id || index}>
                                    <td>
                                        {row.publication_date
                                            ? dateUtils.convertDateToDate(row.publication_date, INTERNATIONAL_DATE_FORMAT)
                                            : '-'}
                                    </td>
                                    <td>{row.court_city || '-'}</td>
                                    <td>{row.insolvency_id || '-'}</td>
                                    <td>{row.publication_label || '-'}</td>
                                    <td>{row.register || '-'}</td>
                                    <td>{row.event_notice || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(InsolvencyPublications);
